import SwaggerUIBundle from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css";
var api = require("./api.json");

export default {
  components: {
    SwaggerUIBundle,
  },
  data() {
    return {};
  },
  mounted: function() {
    this.$nextTick(function() {
      var ui = SwaggerUIBundle({
        spec: api,
        dom_id: "#swagger-ui",
        deepLinking: false,
        presets: [SwaggerUIBundle.presets.apis],
        plugins: [SwaggerUIBundle.plugins.DownloadUrl],
      });
    });
  },
};
